<button type="button" class="button primary" *ngIf="type==='primary'">{{label}}</button>
<button type="button" class="button outline" *ngIf="type==='outline'">{{label}}</button>